export default {"src":"/_next/static/media/dng_logo.e7d8f8bc.svg","height":36,"width":107,"blurWidth":0,"blurHeight":0};